import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23ZM10.9996 9.04019L7.61829 7.13818L6.63776 8.88133L8.45877 9.90565L6.59961 11.3L7.79961 12.9L10.9996 10.5L10.9996 9.04019ZM15.5404 9.90565L17.3614 8.88133L16.3809 7.13818L12.9996 9.04019L12.9996 10.5L16.1996 12.9L17.3996 11.3L15.5404 9.90565ZM11.9996 13C10.1477 13 8.53217 14.0074 7.66915 15.4993L7.16843 16.3649L8.89964 17.3664L9.40036 16.5007C9.92059 15.6014 10.8905 15 11.9996 15C13.1088 15 14.0787 15.6014 14.5989 16.5007L15.0996 17.3664L16.8308 16.3649L16.3301 15.4993C15.4671 14.0074 13.8516 13 11.9996 13Z"}}]};

const Uncomfortable1Filled = Vue.extend<IconProps>({
  name: 'Uncomfortable1FilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'uncomfortable-1-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Uncomfortable1Filled;
